import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { InactivityService } from './services/inactivity/inactivity.service';
import { SessionExpiryWarningService } from './services/session-expiry/session-expiry-warning.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
    private readonly inactivityService = inject(InactivityService);
    private readonly sessionExpiryWarning = inject(SessionExpiryWarningService);

    ngOnInit(): void {
        initFlowbite();
        this.inactivityService.startTracking();
        this.sessionExpiryWarning.startMonitoring();
    }
}

